import { injectable } from 'inversify';
import i18next from 'i18next';

import ConfigService from '../../ConfigService';

@injectable()
export default class VDConfigService extends ConfigService {
  formatSourceLocation = (source?: string) => {
    if (!source) {
      return undefined;
    }

    return `${this.CONFIG_HOST}/appconfig/${source}?locale=${i18next.language}`;
  };
}
